import React from "react";
import { sources, subSources } from "../constants/source-data";
import { SubSourceSelector } from "./sub-source-selector";
import { OtherSourceInput } from "./other-source-input";
import { useSourceScroll } from "../hooks/use-source-scroll";

interface SourceSelectorProps {
  selectedSource: string;
  selectedSubSource: string;
  selectedSubSubSource: string;
  subSourceTexts: Record<string, string>;
  otherSourceText: string;
  onSourceSelect: (sourceLabel: string) => void;
  onSubSourceSelect: (subSourceId: string) => void;
  onSubSubSourceSelect: (subSubSourceId: string) => void;
  onSubSourceTextUpdate: (id: string, value: string) => void;
  onOtherSourceTextChange: (value: string) => void;
  onSubSourceClear: () => void;
  onOtherSourceClear: () => void;
  textInputRef: React.RefObject<HTMLInputElement>;
}

export const SourceSelector: React.FC<SourceSelectorProps> = ({
  selectedSource,
  selectedSubSource,
  selectedSubSubSource,
  subSourceTexts,
  otherSourceText,
  onSourceSelect,
  onSubSourceSelect,
  onSubSubSourceSelect,
  onSubSourceTextUpdate,
  onOtherSourceTextChange,
  onSubSourceClear,
  onOtherSourceClear,
  textInputRef,
}) => {
  const { setSourceRef } = useSourceScroll({ selectedSource, selectedSubSource });

  return (
    <div className="space-y-2">
      {sources.map((source) => (
        <div key={source.id} ref={(el) => setSourceRef(source.id, el)}>
          <button
            onClick={() => {
              onSourceSelect(source.label);
              onSubSourceClear();
              if (source.label !== "기타") {
                onOtherSourceClear();
              }
            }}
            className={`w-full p-3 rounded-lg border-2 transition-all duration-200 ${
              selectedSource === source.label
                ? "border-blue-500 bg-blue-500 text-white shadow-lg transform scale-105"
                : "border-gray-200 text-gray-700"
            }`}
          >
            <div className="flex items-center space-x-2">
              <span
                className={`text-lg ${
                  selectedSource === source.label
                    ? "text-white"
                    : "text-gray-600"
                }`}
              >
                {source.icon}
              </span>
              <span className="font-medium text-sm">{source.label}</span>
            </div>
          </button>

          {/* 하위 소스 UI - 각 소스 버튼 바로 아래에 렌더링 */}
          {selectedSource === source.label && subSources[source.id] && (
            <SubSourceSelector
              sourceId={source.id}
              selectedSubSource={selectedSubSource}
              selectedSubSubSource={selectedSubSubSource}
              onSubSourceSelect={onSubSourceSelect}
              onSubSubSourceSelect={onSubSubSourceSelect}
              onSubSourceTextUpdate={onSubSourceTextUpdate}
              subSourceTexts={subSourceTexts}
              textInputRef={textInputRef}
            />
          )}

          {/* 기타 선택 시 텍스트 입력 필드 (하위 소스가 없는 경우) */}
          {selectedSource === "기타" &&
            source.label === "기타" &&
            !subSources[source.id] && (
              <OtherSourceInput
                otherSourceText={otherSourceText}
                onOtherSourceTextChange={onOtherSourceTextChange}
              />
            )}
        </div>
      ))}
    </div>
  );
};
